import { httpRequest } from '@v4/http/request';
import { getApiUrl } from '@v4/config';
import { stringifyUrl } from '@v4/common/utils/url';

export const baseUrl = `${getApiUrl()}/dkwp/v3/dealers`;

/**
 * Gets the list of dealers by zip code and project id
 *
 * @param {string} zipCode
 * @param {string} projectId
 * @returns {Promise<object>}
 */
export const fetchDealers = (zipCode, projectId) =>
    httpRequest({ url: stringifyUrl({ url: `${baseUrl}/${zipCode}/${projectId}` }) });
